/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';

const render = () => {};

registerPlugin( 'ka-up-cart-block', {
	render,
	scope: 'woocommerce-checkout',
} );
